export default "__VITE_ASSET__CgXszbwh__"